/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { AnnotationSettingsComponent } from './annotation-settings.component';
import { SysqueFrameModule } from '../../../../../../../shared/ui/src/lib/components/sysque-frame';
import { AnnotationSettingsTabModule } from './annotation-settings-tab';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/annotation-settings-dialog', component: AnnotationSettingsComponent }];

@NgModule({
  declarations: [AnnotationSettingsComponent],
  imports: [
    CommonModule,
    FormsModule,
    DxButtonModule,
    SysqueFrameModule,
    AlertModule,
    AnnotationSettingsTabModule,
    RouterModule.forChild(routes),
  ],
  exports: [AnnotationSettingsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AnnotationSettingsModule {}
